"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var glob_patterns_exports = {};
__export(glob_patterns_exports, {
  API_ROUTE_GLOB_PATTERN: () => API_ROUTE_GLOB_PATTERN,
  ROUTE_GLOB_PATTERN: () => ROUTE_GLOB_PATTERN,
  ROUTE_NATIVE_EXCLUSION_GLOB_PATTERNS: () => ROUTE_NATIVE_EXCLUSION_GLOB_PATTERNS,
  ROUTE_WEB_EXCLUSION_GLOB_PATTERNS: () => ROUTE_WEB_EXCLUSION_GLOB_PATTERNS
});
module.exports = __toCommonJS(glob_patterns_exports);
var ROUTE_GLOB_PATTERN = "**/*.{ts,tsx}";
var API_ROUTE_GLOB_PATTERN = "**/*+api.{ts,tsx}";
var ROUTE_WEB_EXCLUSION_GLOB_PATTERNS = [
  "**/*.native.{ts,tsx}",
  "**/*.ios.{ts,tsx}",
  "**/*.android.{ts,tsx}"
];
var ROUTE_NATIVE_EXCLUSION_GLOB_PATTERNS = [
  "**/*.web.{ts,tsx}"
];
//# sourceMappingURL=glob-patterns.js.map
